import API from "@vahak/core/dist/_services/const";
import { useVahakMutationQuery } from "@vahak/core/dist/hooks/useVahakQueryClient";
import useVahakHttpClient from "@vahak/core/dist/hooks/useVahakHttpClient";
import queryNames from "../queryNames";
import { ApiErrorResponseType } from "@vahak/core/dist/custom-types/api-error-response-type";

export interface LatAndLongResponse {
    data: Data;
}

export interface Data {
    id: number;
    name: string;
    city_id: number;
    city_name: string;
    state_id: number;
    state_name: string;
    state_code: string;
    latitude: number;
    longitude: number;
    language_short_text: string;
    language_code: number;
    meta_data: MetaData;
}

export interface MetaData {
    name: string;
    city_name: string;
    state_name: string;
    state_code: string;
    language_short_text: string;
    language_code: number;
}

export interface GetLatAndLongBasedOnPlaceIdParams {
    place_id: string;
}

export const useGetLatAndLongBasedOnPlaceIdV1 = () => {
    const { GET } = useVahakHttpClient();

    const getLatAndLongBasedOnPlaceId = ({ place_id }: GetLatAndLongBasedOnPlaceIdParams) => {
        const queryParamObj = {
            place_id
        };
        return GET<LatAndLongResponse, GetLatAndLongBasedOnPlaceIdParams>(API.LAT_LONG_BY_PLACE_ID, queryParamObj);
    };

    return useVahakMutationQuery<LatAndLongResponse, ApiErrorResponseType, GetLatAndLongBasedOnPlaceIdParams>(
        [queryNames.getLatAndLongBasedOnPlaceId],
        getLatAndLongBasedOnPlaceId
    );
};
